import { useEffect } from "react";

import { useCanSeeSection } from "../../auth/permissions.js";
import { useChatOverview } from "../chat/hooks.js";
import { setTrayUnreadBadge } from "./desktopBridge.js";

/**
 * Keep the desktop tray icon's unread-count badge in sync with the live
 * unread-chat total. Mounted once app-wide (in `AppShell`).
 *
 * Reuses the SAME `chat/overview` query the nav badge reads — react-query
 * dedupes by key, so this adds no extra fetch, and the realtime provider's
 * invalidation on every incoming message flows straight through here. Gated on
 * Chat visibility so a user who can't see Chat never drives a tray badge (or a
 * pointless 403); for them the count is pinned at 0 (plain icon).
 *
 * No-op in a plain browser — `setTrayUnreadBadge` short-circuits outside Tauri.
 */
export function useTrayUnreadBadge(): void {
  const canSeeChat = useCanSeeSection("chat");
  const overview = useChatOverview(canSeeChat);
  const unread = canSeeChat ? overview.data?.total_unread ?? 0 : 0;

  useEffect(() => {
    void setTrayUnreadBadge(unread);
  }, [unread]);
}
